<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="accent" block>Upload Employee</v-btn>
      </template>
      <v-card v-if="corporate">
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar size="40">
                <v-img v-if="corporate.images" v-bind:src="corporate.images.banner" alt="banner"></v-img>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ corporate.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-form v-model="Form.valid">
          <Upload
            required
            class="px-3 pt-2text-truncate"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            label="Select File"
            v-model="Form.image"
          ></Upload>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.native="close()">Cancel</v-btn>
            <v-btn text color="primary" :disabled="!Form.valid" @click.native="upload()">Upload</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import corporateService from '../services/corporate';
import numberUtil from '../utils/number';
import loader from '../utils/loader';

export default {
  mixins: [formMixin],
  provide() {
    return { parentValidator: this.$validator };
  },
  props: {
    corporate: Object,
    value: Boolean,
  },
  data: () => ({
    menu: false,
    Form: new Forms({
      data() {
        return {
          valid: false,
          image: null,
        };
      },
    }),
  }),
  computed: {
    numberUtil() {
      return numberUtil;
    },
  },
  methods: {
    upload() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Upload Employee', 'Are you sure for uploading this file?', {
              color: 'primary',
            })
            .then((confirm) => {
              if (confirm) {
                const formData = new FormData();
                formData.append('import', this.Form.image);
                formData.append('organization_id', this.corporate.id);
                corporateService
                  .uploadEmployee(formData)
                  .then(() => {
                    this.$notify({
                      title: 'Upload',
                      text: 'Upload success !!',
                      type: 'success',
                    });
                    this.$emit('success');
                    this.close();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            });
        }
      });
    },
    close() {
      this.menu = false;
      this.resetFormError(null, this.Form);
    },
  },
  components: {
    Upload: loader.component('UploadFile'),
  },
};
</script>
